import * as PIXI from 'pixi.js';
window.PIXI = PIXI;
require("pixi-spine");

import './Imports';
import '../css/index.css';
import GameInterface from './GameInterface';

window.coinGameOP = new GameInterface();
